import { useId } from '../../../core/hooks/useId.js';
import { WithChildren } from '../../../core/types/with-children.js';
import { TimeseriesChartIdContext } from '../context/TimeseriesChartId.context.js';
import { useResetSelectionOnUnmount } from '../hooks/useResetSelectionOnUnmount.js';

export const TimeseriesChartIdProvider = ({ children }: WithChildren) => {
  const chartId = useId();
  useResetSelectionOnUnmount();

  return (
    <TimeseriesChartIdContext.Provider value={chartId}>
      {children}
    </TimeseriesChartIdContext.Provider>
  );
};
